import React from 'react'
import { Alert, Button, Dialog, DialogContent, Stack, Typography } from '@mui/material'
import { uploadCategoryLabel, reviewUploadsUnavailableReason } from './qualityReviewUploads'

export default function ReviewUploadsDialog({ open, onClose, entries, onOpen, openingFileId, onRerun, busy }) {
    const unavailable = reviewUploadsUnavailableReason(entries)
    return <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth aria-labelledby="review-uploads-title">
        <DialogContent>
            <Stack spacing={2}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography id="review-uploads-title" variant="h6" fontWeight={800}>Uploaded files</Typography>
                    <Button onClick={onClose}>Close</Button>
                </Stack>
                <Typography variant="body2" color="text.secondary">View the business-profile documents and review files used for this review.</Typography>
                {unavailable && <Alert severity="info">{unavailable}</Alert>}
                {entries.map((entry, index) => <Stack key={entry.fileId || index} direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ py: 1, borderBottom: '1px solid #e4eaef' }}>
                    <Stack sx={{ minWidth: 0 }}>
                        <Typography fontWeight={700} sx={{ overflowWrap: 'anywhere' }}>{entry.fileName}</Typography>
                        <Typography variant="body2" color="text.secondary">{uploadCategoryLabel(entry.bundleKey)}{!entry.canOpen ? ' · Unavailable' : ''}</Typography>
                    </Stack>
                    <Button variant="outlined" disabled={!entry.canOpen || Boolean(openingFileId) || busy} aria-label={`View ${entry.fileName}`} onClick={() => onOpen(entry)}>
                        {openingFileId && openingFileId === entry.fileId ? 'Opening…' : 'View'}
                    </Button>
                </Stack>)}
                <Button variant="contained" disabled={Boolean(unavailable) || busy} onClick={onRerun}>Add files &amp; rerun</Button>
            </Stack>
        </DialogContent>
    </Dialog>
}
